import React, { useState } from "react";

import CreativeHistory from "../../../components/CreativeHistory";

/**
 * The before/after history for one creative, in v2.
 *
 * WAVE 4. REUSED, NOT REWRITTEN — `components/CreativeHistory.jsx` was swept
 * and is already correct: it distinguishes loading from a real error, sets the
 * server's own detail rather than a generic sentence, and raises no `alert()`.
 * 133 correct lines rewritten for appearance would risk behaviour to gain
 * styling.
 *
 * What v2 adds is REACHABILITY. In v1 this lived only at
 * `/creatives/:creativeId/history`, a route an operator had to already know —
 * nothing inside a creative session linked to it. Here it opens in place, from
 * the session that made the creative.
 */
export default function CreativeHistoryPanel({ creativeId, onClose }) {
  const [open, setOpen] = useState(false);

  if (!creativeId) return null;

  if (!open) {
    return (
      <button type="button" className="btn-ghost btn-sm"
              onClick={() => setOpen(true)}
              data-testid={`ws-history-open-${creativeId}`}>
        Before / after history
      </button>
    );
  }

  return (
    <div className="ws-history" data-testid="ws-history">
      <div className="ws-history-head">
        <span className="ws-chat-title">Feedback history</span>
        <button type="button" className="btn-ghost btn-sm"
                onClick={() => { setOpen(false); if (onClose) onClose(); }}
                data-testid="ws-history-close">Close</button>
      </div>
      {/* The v1 component owns the read and its three states. */}
      <CreativeHistory creativeId={creativeId} />
    </div>
  );
}
